<script setup>
import { useEventStore } from '@/@vxapp/Events/useEventStore'
import EventPreviewPage from '@/views/setup/events/preview/EventPreviewPage.vue'
import { setPageTitle } from '@/@core/utils/pageMetaUtils'
import { PageMeta } from '@/@vxapp/@Enums/PageMeta'
import HorizontalEventsMenu from '@/components/Menus/Events/HorizontalEventsMenu.vue'

setPageTitle(PageMeta.Events.Preview.Title)
definePage({ meta: PageMeta.Events.Preview.Meta })

const route = useRoute()
const eventsStore = useEventStore()

watch(
  () => eventsStore.messagesVariables,
  () => {
    setPageTitle('Event')
  },
  { deep: true, immediate: false }
)

/* ** */
</script>

<template>
  <section>
    <!-- Horizontal Menu / Navigation -->
    <VRow>
      <VCol cols="12">
        <HorizontalEventsMenu :event-g-u-i-d="route.params.guid" />
      </VCol>
    </VRow>

    <!-- Page -->
    <VRow>
      <VCol cols="12">
        <EventPreviewPage
          v-if="route.params.guid"
          :event-g-u-i-d="route.params.guid"
        />
      </VCol>
    </VRow>
  </section>
</template>
